module.exports = __webpack_public_path__ + "assets/img/cloud3.d0dacb68.png";